module.exports = __webpack_public_path__ + "static/media/photo-login.333f684d.jpeg";